// extracted by mini-css-extract-plugin
export default {"productGallery":"WK-z","inQuickShop":"XK-z"};